export enum FormViewType {
  CREATE = 'create',
  EDIT = 'edit',
}
